// extracted by mini-css-extract-plugin
module.exports = {"button":"loginButton-module--button--aRnD_","responsiveButton":"loginButton-module--responsive-button--3K268"};